import {
    Navigate,
} from 'react-router-dom';
import MainLayout from '../layout/MainLayout';
import { useAppSelector } from '../app/hooks';
import { selectCurrentUser } from '../features/auth/authSlice';
import { UserProviderId, UserRole } from 'models/IUser';

export type PrivateRouteProps = {
    authenticationPath: string;
    outlet: JSX.Element;
    allowedRoles?: UserRole[];
    allowedProviders?: UserProviderId[];
};

export default function PrivateRoute({ authenticationPath, outlet, allowedRoles, allowedProviders }: PrivateRouteProps) {
    const authUser = useAppSelector(selectCurrentUser);

    if (!authUser) {
        return <Navigate to={{ pathname: authenticationPath }} />;
    }

    if (allowedRoles && (authUser.role === undefined || !allowedRoles.includes(authUser.role))) {
        return <Navigate to={{ pathname: '/404' }} />;
    }

    if (allowedProviders && (authUser.provider === undefined || !allowedProviders.includes(authUser.provider as UserProviderId))) {
        return <Navigate to={{ pathname: '/404' }} />;
    }

    return (
        <MainLayout>
            {outlet}
        </MainLayout>
    );
};